import { render, staticRenderFns } from "./profiles.vue?vue&type=template&id=138cf27b&scoped=true&"
var script = {}
import style0 from "./profiles.vue?vue&type=style&index=0&id=138cf27b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138cf27b",
  null
  
)

export default component.exports